import { ExternalClientStylesService } from "src/app/external-client-styles/external-client-styles.service";
import { LogoService } from "./logo.service";
import { AttributesService } from "src/app/processes/attributes.service";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth.service";

export const ExternalClientsStylesCacheKey = "ExternalClientsStyles";
export const UserAttributesCacheKey = "UserAttributesCacheKey";

export function applyExternalClientStyles(
    attributeService: AttributesService,
    stylesService: ExternalClientStylesService,
    logoService: LogoService,
    authService: AuthService,
    userId?: string,
): void {
    attributeService.getUserAttributes(userId).subscribe(
        (response) => {
            const userAttributes = response.data || [];
            stylesService.getAllExternalClientStyles().subscribe(
                (res) => {
                    const allStyles = res.data || [];

                    const matchedStyle = allStyles.find(style =>
                        userAttributes.some(attr => attr.id === style.attributeId)
                    );


                    if (matchedStyle && (userId === authService.getLoggedUserId() || !matchedStyle.onlyWhenLogged)) {
                        setStyles(matchedStyle, logoService);

                        localStorage.setItem(ExternalClientsStylesCacheKey, btoa(JSON.stringify(allStyles)));
                        localStorage.setItem(UserAttributesCacheKey, btoa(JSON.stringify(userAttributes)));
                    }

                    if (!matchedStyle) {

                        const defaultStyle = allStyles.find(style => style.default);
                        if (defaultStyle) {
                            setStyles(defaultStyle, logoService);
                        }
                    }
                },
                (error) => console.error(error)
            );
        },
        (error) => console.error(error)
    );
}

export function applyCachedExternalClientStyles(
    logoService: LogoService,
    authService: AuthService,
    userId?: string,
): void {
    const allStylesEncoded = localStorage.getItem(ExternalClientsStylesCacheKey);
    const userAttributesEncoded = localStorage.getItem(UserAttributesCacheKey);

    let allStyles = allStylesEncoded ? JSON.parse(atob(allStylesEncoded)) : null;
    let userAttributes = userAttributesEncoded ? JSON.parse(atob(userAttributesEncoded)) : null;

    if (allStyles === null || userAttributes === null) return;

    const matchedStyle = allStyles.find(style =>
        userAttributes.some(attr => attr.id === style.attributeId)
    );

    if (matchedStyle && (userId === authService.getLoggedUserId() || !matchedStyle.onlyWhenLogged)) {
        setStyles(matchedStyle, logoService);
    }

    if (!matchedStyle) {
        const defaultStyle = allStyles.find(style => style.default);
        if (defaultStyle) {
            setStyles(defaultStyle, logoService);
        }
    }
}

export function setDefaultStyles() {
    let defaultStyleEncoded = localStorage.getItem(ExternalClientsStylesCacheKey);
    let defaultStyle = defaultStyleEncoded ? JSON.parse(atob(defaultStyleEncoded)) : null;
    if (defaultStyle) {
        const style = defaultStyle.find((style: any) => style.default);
        if (style) {
            setStyles(style, new LogoService());
        }
    }
}

function setStyles(style: any, logoService: LogoService): void {
    const styleMap: { [key: string]: string | undefined } = {
        '--ion-color-primary': style.primaryColor,
        '--ion-color-secondary': style.secondaryColor,
        '--ion-color-primary-shade': style.primaryShade,
        '--ion-color-primary-tint': style.primaryTint,
        '--ion-color-success': style.successColor,
        '--ion-color-danger': style.errorColor,
        '--ion-color-contrast': style.contrastColor,
        '--ion-color-primary-contrast': style.contrastColor,
        '--background-hover': style.backgroundColor ? style.backgroundColor : null,
        '--logo-color': style.secondaryColor,
        '--primary-color': style.primaryColor,
        '--semi-primary-color': style.primaryColor,
        '--card-primary-color': style.primaryColor,
        '--login-card-button': style.primaryColor,
        '--login-card-enter': style.primaryColor,
        '--top-type-config-color': style.primaryColor,
        '--primary-text-color': style.secondaryColor,
        '--icon-primary-color': style.secondaryColor,
        '--light-color': style.primaryColor,
        '--toolbar-background-color': style.toolbarBackgroundColor,
    };

    for (const [cssVar, value] of Object.entries(styleMap)) {
        if (value) {
            document.documentElement.style.setProperty(cssVar, value);
        }
    }

    if (style.logoUrl) {
        logoService.Logo = style.logoUrl;
        environment.logo = style.logoUrl;
    }
}
